import { render, staticRenderFns } from "./quickTrainerReg.vue?vue&type=template&id=72b736f0&scoped=true"
import script from "./quickTrainerReg.vue?vue&type=script&lang=js"
export * from "./quickTrainerReg.vue?vue&type=script&lang=js"
import style0 from "./quickTrainerReg.vue?vue&type=style&index=0&id=72b736f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b736f0",
  null
  
)

export default component.exports